class AddToBag extends HTMLElement {
  constructor() {
    super();
    this.timer = undefined; // Timer to remove the modal after 3 seconds
  }

  setPrice(selector, price) {
    this.querySelector(selector).textContent = `$${(price / 100).toFixed(2)}`;
  }

  setOption(selector, value) {
    this.querySelector(selector).textContent = value;
  }

  revealModal() {
    this.querySelector('.CartATB__modal').classList.add('revealed');
    this.querySelector('.CartATB__overlay').classList.add('CartATB__overlay--show');
  }

  removeContent() {
    this.querySelector('.CartATB__modal').classList.remove('revealed');
    this.querySelector('.CartATB__overlay').classList.remove('CartATB__overlay--show');
    this.querySelector('#cart-atb').innerHTML = '';
  }

  setImage(selector, imageSource) {
    return new Promise((resolve, reject) => {
      const imgElem = this.querySelector(selector);

      imgElem.onload = () => resolve('okay');
      imgElem.onerror = reject;
      imgElem.src = imageSource;
    });
  }

  connectedCallback() {
    this.querySelector('.CartATB__close').addEventListener('click', () => this.removeContent());

    document.addEventListener('cartItemAdded', (event) => {
      // Get Product JSON data and selected variant
      const data = event.detail;
      const variantId = data.variantId;
      const selectedVariant = data.productJson.variants.find((variant) => variant.id.toString() === variantId);
      const imageSource = `https:${selectedVariant.featured_image.src}&width=100`;

      // Set the price
      if (selectedVariant.compare_at_price > selectedVariant.price) {
        this.setPrice('#cart-atb-compare-price', selectedVariant.compare_at_price);
        this.setPrice('#cart-atb-price', selectedVariant.price);
      } else {
        this.setPrice('#cart-atb-price', selectedVariant.price);
      }

      // Set the image and options
      this.setOption('#cart-atb-option1>span.CartATB__item-value', selectedVariant.option1);
      this.setOption('#cart-atb-option2>span.CartATB__item-value', selectedVariant.option2);
      this.setImage('.CartATB__image>img', imageSource).then(() => this.revealModal()); // Show the modal once the image is loaded

      document.dispatchEvent(new CustomEvent('rtb_add_to_cart', { detail: data.variantId })); // Dispatch event to track event in GTM

      if (this.timer) {
        // Clear any timer if it exists
        clearTimeout(this.timer);
      }
    });

    document.addEventListener('cartDidUpdate', () => {
      this.timer = setTimeout(() => this.removeContent(), 3000);
    });
  }
}

export default AddToBag;
